import React, { useState } from "react";
import FleetrifyCard from "../../components/Card";
import DashboardLayout from "../../components/DashboardLayout";
import AuditLogTable from "../../components/Table/AuditLogTable";
import useAuditLogControllers from "../../controllers/useAuditLogControllers";
import SingleAuditLogDrawer from "../../components/pages/AuditLog/modal/singleAuditLogDrawer";
import AuditLogFilter from "../../components/pages/AuditLogFilter/AuditLogFilter";

const Auditlog = () => {
  const {
    auditLogs,
    pageSize,
    totalPage,
    lastPage,
    total,
    currentPage,
    setCurrentPage,
  } = useAuditLogControllers();

  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filteredLogs, setFilteredLogs] = useState(auditLogs);

  const handleRowClick = (row: any) => {
    setSelectedLog(row);
    setDrawerOpen(true);
  };

  return (
    <DashboardLayout
      title="Audit Log"
      description="Track every action, ensure accountability."
      containerClass=""
      showDateRange={true}
      onDataRefresh={() => console.log("Data refreshed")}
    >

      <FleetrifyCard cardContainerClass="mt-10">

        <div>
          <AuditLogFilter logs={auditLogs} onFilter={setFilteredLogs} />
        </div>

        <AuditLogTable
          tableData={filteredLogs}
          pageSize={pageSize}
          totalPage={totalPage}
          lastPage={lastPage}
          total={total}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onRowClick={handleRowClick}
        />
      </FleetrifyCard>

      <SingleAuditLogDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        logData={selectedLog}
      />
    </DashboardLayout>
  );
};

export default Auditlog;